
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DocumentCard from '@/components/dashboard/shared/components/DocumentCard.vue';
import axios from 'axios';
import { api } from '@/api';
import { MediaResource } from '@/interfaces/Models';

@Component({
    components: {
        DocumentCard
    }
})
export default class Documents extends Vue {
    
    @Prop()
    id!: number;

    public documentsLoading: boolean = false;

    public avatar: MediaResource | null = null;
    public cvEn: MediaResource | null = null;
    public cvSr: MediaResource | null = null;
    public idCard: MediaResource | null = null;
    public courtCert: MediaResource | null = null;
    public policeCert: MediaResource | null = null;
    public firstAidCert: MediaResource | null = null;
    public psychTestReport: MediaResource | null = null;

    public setDocuments(media: any): void {
        this.avatar = media.avatar;
        this.cvEn = media.cv_english;
        this.cvSr = media.cv_serbian;
        this.idCard = media.id_card;
        this.courtCert = media.court_cert;
        this.policeCert = media.police_cert;
        this.firstAidCert = media.first_aid_cert;
        this.psychTestReport = media.psych_test_report;
    }

    public getApiPathByKey(key: string): string {
        return api.path(`v1.admin.babysitters.documents.${key}`, { id: this.id });
    }

    public get documentsFormat(): { key: string, fileTypes: string[], resource: MediaResource | null }[] {
        return [
            {
                key: 'avatar',
                fileTypes: ['image'],
                resource: this.avatar,
            },
            {
                key: 'cv_sr',
                fileTypes: ['image', 'pdf'],
                resource: this.cvSr,
            },
            {
                key: 'cv_en',
                fileTypes: ['image', 'pdf'],
                resource: this.cvEn,
            },
            {
                key: 'id_card',
                fileTypes: ['image', 'pdf'],
                resource: this.idCard,
            },
            {
                key: 'court_cert',
                fileTypes: ['image', 'pdf'],
                resource: this.courtCert,
            },
            {
                key: 'police_cert',
                fileTypes: ['image', 'pdf'],
                resource: this.policeCert,
            },
            {
                key: 'first_aid_cert',
                fileTypes: ['image', 'pdf'],
                resource: this.firstAidCert,
            },
            {
                key: 'psych_test_report',
                fileTypes: ['pdf'],
                resource: this.psychTestReport,
            },
        ]
    }
    
    public loadDocuments() {

        this.documentsLoading = true;

        axios.get(api.path('v1.admin.babysitters.documents', { id: this.id }))
            .then(res => this.setDocuments(res.data.data))
            .finally(() => this.documentsLoading = false);
    }

    public mounted() {
        this.loadDocuments();
    }

}
